import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';

const LoginPage = () => {
    const navigate = useNavigate();

    const {
        error,
        login,
        isLoggedIn
    } = useAuth();

    const { state } = useLocation();
    const prefill = state?.prefill || {};
    const [extras, setExtras] = useState(prefill);

    const [email, setEmail] = useState(prefill.email ?? "");
    const [password, setPassword] = useState('');


    useEffect(() => {
        if (isLoggedIn) {
            const target = prefill.link && prefill.link.startsWith("/") ? prefill.link : "/dashboard";
            navigate(target, { replace: true });
        }
    }, [isLoggedIn, navigate, prefill.link]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const ok = await login(email, password);
        if (!ok) return;
        const target = prefill.link && prefill.link.startsWith("/") ? prefill.link : "/dashboard";
        navigate(target, { replace: true, state: { fromLogin: true } });
    };

    const [version, setVersion] = useState("");

    console.log(extras);

    useEffect(() => {
        fetch("/version.txt")
            .then(response => response.text())
            .then(text => setVersion(text.trim()));
    }, []);

    return (
        <div className="flex md:flex-row flex-col w-screen h-screen">
            <div className="relative flex justify-around items-center bg-gradient-to-tr from-orange-600 to-orange-400 *:border-white w-full md:w-1/2 h-2/5 md:h-full overflow-hidden">
                <div className="z-10 relative px-10">
                    <h1 className="font-sans font-bold text-white text-4xl">SavPlus</h1>
                    <p className="mt-1 text-white">La meilleure gestion de Service Après Vente</p>
                    <a
                        href="https://savplus-btp.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block bg-white mt-4 mb-2 py-2 rounded-2xl w-28 font-bold text-orange-600 text-center transition hover:translate-y-[-2px] duration-300"
                    >
                        En savoir plus
                    </a>
                </div>
                <div className="-bottom-32 -left-40 absolute border-4 border-t-8 border-opacity-30 rounded-full w-80 h-80"></div>
                <div className="-bottom-40 -left-20 absolute border-4 border-t-8 border-opacity-30 rounded-full w-80 h-80"></div>
                <div className="-top-40 -right-0 absolute border-4 border-t-8 border-opacity-30 rounded-full w-80 h-80"></div>
                <div className="-top-20 -right-20 absolute border-4 border-t-8 border-opacity-30 rounded-full w-80 h-80"></div>

                <div className="right-0 bottom-0 absolute">
                    <p className="p-5 px-10 font-bold text-white text-sm" style={{ fontFamily: "'Source Code Pro', monospace" }}>v{version}</p>
                </div>
            </div>
            <div className="flex justify-center items-center bg-white py-10 w-full md:w-1/2 h-2/5 md:h-full">
                <form onSubmit={handleSubmit} className="bg-white w-60">
                    <h1 className="mb-1 font-bold text-gray-800 text-2xl text-center">Bonjour!</h1>
                    <p className="mb-7 font-normal text-gray-600 text-sm text-center">Content de te revoir</p>
                    <div className="flex items-center mb-4 px-3 py-2 border-2 hover:border-orange-400 rounded-2xl transition duration-400">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-gray-400" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                        </svg>
                        <input
                            className="pl-2 border-none outline-none w-full"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            id="email"
                            name="email"
                            type="email"
                            placeholder="Email"
                        />
                    </div>
                    <div className="flex items-center px-3 py-2 border-2 hover:border-orange-400 rounded-2xl transition duration-400">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-gray-400" viewBox="0 0 20 20"
                            fill="currentColor">
                            <path fillRule="evenodd"
                                d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                                clipRule="evenodd" />
                        </svg>
                        <input
                            className="pl-2 border-none outline-none w-full"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            id="password"
                            name="password"
                            type="password"
                            placeholder="Mot de Passe"
                        />
                    </div>
                    {error && <p className="pt-4 pl-2 text-red-500 text-sm text-center">{error}</p>}
                    <button type="submit" className="block bg-orange-600 hover:bg-orange-500 mt-4 mb-2 py-2 rounded-2xl w-full font-semibold text-white transition hover:translate-y-[-2px] duration-300">
                        Se Connecter
                    </button>
                    <p className="pt-2 hover:text-blue-500 text-sm text-center transition duration-200 cursor-pointer">
                        Mot de passe oublié ?
                    </p>
                </form>
            </div>
            <div className="md:hidden visible relative flex justify-around items-center bg-gradient-to-tr from-orange-600 to-orange-400 w-full md:w-1/2 h-1/5 md:h-full overflow-hidden">
                <div className="-bottom-32 -left-40 absolute border-4 border-t-8 border-opacity-30 rounded-full w-80 h-80"></div>
                <div className="-bottom-40 -left-20 absolute border-4 border-t-8 border-opacity-30 rounded-full w-80 h-80"></div>
                <div className="-top-40 -right-0 absolute border-4 border-t-8 border-opacity-30 rounded-full w-80 h-80"></div>
                <div className="-top-20 -right-20 absolute border-4 border-t-8 border-opacity-30 rounded-full w-80 h-80"></div>
            </div>
        </div>
    );
};

export default LoginPage;
